import User from "@/types/user"
import type { NavItem } from "@xy-planning-network/trees/types/composables/nav"

/**
 * Get the base navigation for the sidebar with user context
 * @param user The current user
 * @returns Array<Navitem> an array of navigation items
 */
export function useBaseNavigation(user: User): Array<NavItem> {
  return [
    {
      name: "Dashboard",
      url: "/dashboard",
      display: user.accountOwner,
    },
    {
      name: "Sources",
      url: "/sources",
      display: true,
    },
    {
      name: "Data",
      url: "/data",
      display: true,
    },
    {
      name: "Websites",
      url: "/websites",
      display: true,
    },
    {
      name: "Reviews",
      url: "/reviews",
      display: user.accountOwner,
    },
    {
      name: "|",
      url: "#",
      display: user.login?.superAdmin,
    },
    {
      name: "Admin",
      url: "/admin/accounts",
      display: user.login?.superAdmin,
    },
  ].filter((item) => item.display)
}
